import React from "react";
import { Column, ColumnId } from ".";
import base from "./base";
import ReceiptStatusCellContent from "../components/ReceiptStatusCellContent";

function receiptStatus({ width, onResize, language }: Column.Options) {
	return base(
		ColumnId.ReceiptStatus,
		(item) => (
			<ReceiptStatusCellContent item={item} language={language} />
		),
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default receiptStatus;
